export default __webpack_public_path__ + "static/media/arrow_right_circle.d2bba460.svg";